export default {"src":"/_next/static/media/twitterIconWhite.23cf4750.svg","height":204,"width":248};